import styles from "./Message.module.scss"
import useAppSelector from "../../hooks/useAppSelector";
import useAppDispatch from "../../hooks/useAppDispatch";
import {useEffect} from "react";
import closeIcon from "../../assets/images/icons/close-message.svg";
import successIcon from "../../assets/images/icons/success-message.svg";
import errorIcon from "../../assets/images/icons/error-message.svg";
import {closeMessage} from "../../store/notification/notificationSlice";

const Message = () => {

    const {
        title,
        description,
        type
    } = useAppSelector(state => state.notificationSlice.message);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (title) {
            const timeout = setTimeout(() => {
                dispatch(closeMessage());
            }, 2000)
            return () => clearTimeout(timeout);
        }
    }, [title]);

    const findIconForMessage = (value: "success" | "error" | "warning" | null) => {
        let icon;
        switch (value) {
            case "success":
                icon = successIcon;
                break;
            case "error":
                icon = errorIcon;
                break;
            default:
                icon = successIcon;
                break;
        }
        return icon;
    }

    const close = () => {
        dispatch(closeMessage());
    }

    return (
        <>
            {title && <div className={`${styles.container} ${type === "success" ? styles.success : styles.error}`}>
                <div className={styles.row}>
                    <div>
                        <img src={findIconForMessage(type)} alt={type ? type : ""}/>
                        <h4 className={styles.title}>{title}</h4>
                    </div>
                    <img onClick={close} className={styles.close} src={closeIcon} alt={"close"}/>
                </div>
                {description && <p className={styles.description}>{description}</p>}
            </div>}
        </>
    )
}

export default Message;